import dayjs, { Dayjs } from 'dayjs';

import { ScheduleBalanceForm } from './form';

import { BalanceScheduleModel } from 'v2/types/ScheduleModel';

// time from server in format HH:mm
export function formatTimeToPicker(time: string): Dayjs {
  const [hour, minutes] = time.split(':');

  return dayjs().hour(Number(hour)).minute(Number(minutes));
}

export function mapFormToDto(form: ScheduleBalanceForm): (Omit<BalanceScheduleModel, 'id'> & { id?: string })[] {
  return form.schedules.reduce(
    (acc, cur) => {
      const { time, ...rest } = cur;

      acc.push({ ...rest, time: time.format('HH:mm') });

      return acc;
    },
    [] as (Omit<BalanceScheduleModel, 'id'> & { id?: string })[]
  );
}
